export default __webpack_public_path__ + "1e538680c4cfa09be90e81ac4ec25922.svg";